import { theme } from '@prophecy/theme';
import { Stack } from '@prophecy/ui-v3/Layout';
import { TABLE_CONTAINER } from '@prophecy/ui-v3/Table/tokens';
import styled from 'styled-components';

export const ScrollableStack = styled(Stack)`
  min-height: 0;
  max-height: 100%;
  overflow: auto;
  padding-left: ${theme.spaces.x4};
  padding-right: ${theme.spaces.x8};
  padding-bottom: ${theme.spaces.x24};
  . ${TABLE_CONTAINER} {
    min-height: 70px;
  }
`;
